<template lang="pug">
div v {{ version }}
  span.ms-1.capitalize ({{ style }})
</template>

<script setup>
import { computed } from 'vue'

import pkg from '../package.json'

import { useRuntimeConfig } from '#app'

const config = useRuntimeConfig()

// const version = config.public.gitSha || pkg.version;
const version = pkg.version

const style = computed(() => {
  return config.public.style || ''
})
</script>

<style scoped></style>
